module.exports = {
  "country": "IT",
  "artist": "Måneskin",
  "song": "Zitti e bouni",
  "year": "2021",
  "place": "1",
  "spotify": "776AftMmFFAWUIEAb3lHhw"
};